'use client';

import PropTypes from 'prop-types';
import {getThumbnailUrl} from "@/utils/image-utils.ts";

import Box from "@mui/material/Box";

import Image from "src/components/image";
import Lightbox, {useLightBox} from "src/components/lightbox";

function RecipeGallery({recipeData}) {
  const photos = [];

  if (recipeData.photo?.url ?? false) {
    photos.push({
      src: getThumbnailUrl(recipeData.photo, 'strona')
    });
  }

  recipeData.steps?.forEach(step => {
    step.images?.forEach(stepImage => {
      const imageData = {
        src: stepImage.url
      };

      const imageThumbnail = getThumbnailUrl(stepImage, '270_270');
      if (imageThumbnail) {
        imageData.src_mini = imageThumbnail;
      }

      photos.push(imageData);
    });
  });

  const {
    selected: selectedImage,
    open: openLightbox,
    onOpen: handleOpenLightbox,
    onClose: handleCloseLightbox,
  } = useLightBox(photos);

  if (photos.length < 1) {
    return '';
  }

  return (
    <>
      <Box
        gap={1}
        display="grid"
        gridTemplateColumns={{
          xs: 'repeat(1, 1fr)',
          md: photos.length > 1 ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)',
        }}
        sx={{
          mb: {xs: 3, md: 5},
        }}
      >
        <div
          key={photos[0].src}
        >
          <Image
            fetchPriority="high"
            alt={photos[0].src}
            src={photos[0].src}
            ratio="1/1"
            onClick={() => handleOpenLightbox(photos[0].src)}
            sx={{
              borderRadius: 2,
              cursor: 'pointer',
              maxHeight: photos.length > 1 ? 'none' : 600
            }}
          />
        </div>

        <Box gap={1} display="grid" gridTemplateColumns={photos.length > 2 ? 'repeat(2, 1fr)' : 'repeat(1, 1fr)'}>
          {photos.slice(1, 5).map((photo) => (
            <div
              key={photo.src}
            >
              <Image
                alt={photo.src_mini ?? photo.src}
                src={photo.src_mini ?? photo.src}
                ratio="1/1"
                onClick={() => handleOpenLightbox(photo.src)}
                sx={{borderRadius: 2, cursor: 'pointer'}}
              />
            </div>
          ))}
        </Box>
      </Box>

      <Lightbox
        index={selectedImage}
        slides={photos}
        open={openLightbox}
        close={handleCloseLightbox}
        disabledCaptions
        disabledSlideshow
        disabledFullscreen
        disabledZoom
      />
    </>
  );
}

RecipeGallery.propTypes = {
  recipeData: PropTypes.object
};

export default RecipeGallery;
